import React from "react";
import "./RummyTableHistoryInnerRoundCards.css";
import { Modal } from "react-bootstrap";

const getSuitSymbol = (suit) => {
  switch (suit) {
    case "C":
      return "♣";
    case "D":
      return "♦";
    case "H":
      return "♥";
    case "S":
      return "♠";
    default:
      return suit;
  }
};

const getRankName = (rank) => {
  switch (String(rank)) {
    case "14":
      return "A";
    case "11":
      return "J";
    case "12":
      return "Q";
    case "13":
      return "K";
    default:
      return rank;
  }
};

function parseCards(name) {
  try {
    // Your stored value:
    // {"rank":"4",...}, {"rank":"7",...}

    return JSON.parse(`[${name}]`);
  } catch (error) {
    console.error("Card parse error:", error);
    return [];
  }
}

function RummyTableHistoryInnerRoundCards(props) {
  const cardsData = props?.rummyWalletHistoryCards || [];

  return (
    <div className="Successfull_Modal_sec">
      <Modal
        className="Successfull_Modal"
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton>
          <Modal.Title>Player Round History Cards</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="rummy-all-groups">
            {cardsData.length > 0 ? (
              cardsData.map((item, index) => {
                const cards = parseCards(item?.name);

                return (
                  <div className="rummy-card-group" key={item.id || index}>
                    {/* Cards */}
                    <div className="rummy-cards-list">
                      {cards.length > 0 ? (
                        cards.map((card, cardIndex) => {
                          const suit = getSuitSymbol(card.suit);
                          const rank = getRankName(card.rank);

                          const isRed = card.suit === "H" || card.suit === "D";

                          return (
                            <div
                              className={`rummy-playing-card ${
                                isRed ? "red-card" : "black-card"
                              }`}
                              key={cardIndex}>
                              <div className="card-rank">{rank}</div>

                              <div className="card-suit">{suit}</div>

                              {card.is_joker && (
                                <div className="card-joker">JOKER</div>
                              )}
                            </div>
                          );
                        })
                      ) : (
                        <span className="no-cards">No cards</span>
                      )}
                    </div>

                    {/* Group name BELOW cards */}
                    <div className="rummy-group-name">Group {index + 1}</div>
                  </div>
                );
              })
            ) : (
              <div className="no-history">No round history found</div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default RummyTableHistoryInnerRoundCards;
